import { useMutation, useQueryClient } from '@tanstack/react-query';

import { equipmentsViewKey } from '@pages/SensorsList/services/useEquipmentsViewQuery';

import { apiClient } from '@services/apiClient';

import { type IUseSaveEquipmentNotesData } from '../model/equipmentNotes';

const saveEquipmentNotesFn = (data: IUseSaveEquipmentNotesData) => {
  return apiClient.patch(`${APP_API_URL_V2}fsd/equipment/info`, data);
};

export const useSaveEquipmentNotesMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveEquipmentNotesFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [equipmentsViewKey()[0]] });
    },
  });
};
